import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
	selector: 'imv-dialog-confirm',
	templateUrl: './dialog-confirm.component.html',
	styleUrls: ['./dialog-confirm.component.scss'],
})
export class DialogConfirmComponent extends DialogComponent implements OnInit, OnDestroy {
	override CUSTOM_ERRORS: string[] = ['JWT_MATCH'];
	cancel: string | undefined;

	override ngOnInit(): void {
		this.loadSubscriptions();
	}

	override setLabels = () => {
		const errorCode = this.error?.errorCode;
		const i18nEntry = this.i18n?.[errorCode] ?? this.translateService.instant(`shared.dialogs.${errorCode}`);

		if (i18nEntry && typeof i18nEntry === 'object') {
			const { title, description, action, cancel } = i18nEntry;
			this.title = title;
			this.description = description;
			this.action = action;
			this.cancel = cancel;
		} else {
			this.title = 'Ha ocurrido un error';
			this.description = this.error.message;
			this.action = 'Aceptar';
			this.cancel = 'Cancelar';
		}
		this.traces = this.error.traces || this.error.errors || [];
	};

	accept = () => {
		const errorCode = this.error.errorCode;
		this.dialogEmitter('ACCEPT', errorCode);
		this.modal.close();
	};
}
